import { DatePipe } from '@angular/common';
import { Input } from '@angular/core';
import { Output } from '@angular/core';
import { ViewChild } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { HostListener } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent } from '@ng-select/ng-select';

import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogService } from 'src/app/components/confirmation-dialog/confirmation-dialog.service';
import { AddadjtypeComponent } from 'src/app/components/adjtype/addadjtype/addadjtype.component';
import { ComponentCanDeactivate } from 'src/app/components/PendingChangesGuard';
import { AddproductComponent } from 'src/app/components/product/addproduct/addproduct.component';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { AddrawmaterialComponent } from 'src/app/components/rawmaterial/addrawmaterial/addrawmaterial.component';
import { AddadjdetailComponent } from '../addadjdetail/addadjdetail.component';
@Component({
  selector: 'app-addadj',
  templateUrl: './addadj.component.html',
  styleUrls: ['./addadj.component.css']
})
export class AddadjComponent implements OnInit, ComponentCanDeactivate {

  @ViewChild('Selecter', { static: false }) ngselect: NgSelectComponent;

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;
  ischeck: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  isload: boolean = true;

  israwmaterialaddmode: boolean = false;
  isadjtypeaddmode: boolean = false;

  rtnform: string = "";
  errtxt: any = "";

  //Edit Get Values
  adjmainColl: any = [];

  adjBO: any = {}
  adjtypeColl: any = [];

  adjdetailscoll: any = [];

  ismanualclose: boolean;

  qtytotal: number = 0;
  unitpricetotal: number = 0;
  subtotal: number = 0;


  discounttype: string = "";

  productfindColl: any;
  taxColl: any;
  uomColl:any;
  rawmaterialColl: any;
  isLoadingResult: boolean;

  filterpaymentmodeid: number = 0;

  adjform = new FormGroup({
    adjid: new FormControl(0),
    adjno: new FormControl('', Validators.required),
    adjdate: new FormControl(null, Validators.required),
    refno: new FormControl(''),
    grandtotal: new FormControl(null),
    descr: new FormControl(''),
    adjtypeid: new FormControl(null, Validators.required),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Adj";

  gridfocusrow: number = -1;

  @Input() adjid: number = 0
  @Input() filteradjtypeid: number = null;
  @Input() filterfromdate: any = null;
  @Input() filtertodate: any = null;
  @Input() formmode: String = "";


  @Output() emitData = new EventEmitter();

  currencyMask:any="";

  constructor(private appService: DhukanDataService, private activeModal: NgbActiveModal, private route: ActivatedRoute,
    private productFindService: NgbModal, private confirmationDialogService: ConfirmationDialogService,
    public router: Router, private toastr: ToastrService, public loginService: LoginDataService, private datePipe: DatePipe) {

      this.currencyMask=this.loginService.fngetDecimalPlaces()
      
    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }

        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.adjform.reset();
      this.fnInitializeForm();

      if (this.adjid > 0) {
        this.fngetAdj();
      }
      else {
        this.fnSetFirstRowItem()
      }
      this.fngetAdjtype();
      this.fnGetRawmaterial();
      this.fnGetUom()
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  ngAfterViewInit() {
    //  this.loginService.fnSetFirstControlFocusLookup(this.ngselect);


  }





  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.adjid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }
    this.israwmaterialaddmode = this.loginService.fnCheckUserRoleAction("Rawmaterial", 'CREATE')
    this.isadjtypeaddmode = this.loginService.fnCheckUserRoleAction("Adjtype", 'CREATE')

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeForm() {
    this.adjform.setValue({
      adjid: 0,
      adjno: 'NEW',
      adjdate: new Date(),
      grandtotal: null,
      descr: null,
      adjtypeid: null,
      refno: '',
      inactive: false,
    })
  }



  fngetAdjtype() {
    var data = {
      'adjtypeid': 0,
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getAdjtype(data)
      .subscribe(
        (res) => {
          this.adjtypeColl = res.json().result;
          //console.log(this.adjtypeColl)
          this.filteradjtypeid = this.adjtypeColl.adjtypeid;

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fnGetUom() {
    this.isLoadingResult = true;

    var data = {
      'uomid': 0,
      'organizationid': this.loginService.fnGetOrganizationId(),
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getUom(data)
      .subscribe(
        (res) => {
          this.uomColl = res.json().result;


          this.isLoadingResult = false;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }



  //Get 
  fngetAdj() {

    var data = {
      'adjid': this.adjid,
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getAdj(data)
      .subscribe(
        (res) => {
          var result = res.json().result;
         
          this.adjmainColl = result[0];

          var editdata = this.adjmainColl[0];
          this.adjBO = editdata;
          this.fnEditMode(editdata);

          this.adjdetailscoll = result[1];
          //console.log(this.adjdetailscoll)

          if (this.adjdetailscoll.length === 0) {
            this.fnSetFirstRowItem()
          }
          this.fnCalcDetails();
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnValidation() {
    var _ischeck = false;
    var _detailscheck = false;
    var _uomcheck = false;

    for (let row of this.adjdetailscoll) {
      if (row.rawmaterialid > 0) {
        _detailscheck = true;       
        if(this.aaNumber(row.uomid)===0){
          _uomcheck=true
        }
      }
    }

    if (!_detailscheck) {
      this.errtxt = "Adjustment Details cannot be empty"
      this.adjform.controls['inactive'].setErrors({ 'notfound': true });
      _ischeck = true;
    }
    if (!_ischeck) {
      if (_uomcheck) {
      this.errtxt = "Unit cannot be empty"
      this.adjform.controls['inactive'].setErrors({ 'notfound': true });
      _ischeck = true;
    }
  }
    
    if (!_ischeck) {
      for (let row of this.adjdetailscoll) {

        if (row.rawmaterialid > 0 && this.loginService.fnCheckZeroDetcimal(row.qty) === 0) {
          this.errtxt = "Quantity is cannot be empty"
          this.adjform.controls['inactive'].setErrors({ 'notfound': true });
          _ischeck = true;
        }

      }
    }
    return _ischeck;

  }

  fnResetValidation() {

    if (this.adjform.get('inactive')) {
      this.adjform.controls['inactive'].setErrors(null);
    }

  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      if (this.saveloading) {
        return;
      }

      this.submitted = true;
      this.successfully = false;

      this.fnResetValidation()
      //Validate

      if (this.adjform.valid) {

        if (this.fnValidation()) {

          return false
        }


        this.saveloading = true;



        //Check
        var data = {
          'adjid': this.adjid,
          'adjno': this.adjform.get('adjno').value,
          'adjdate': this.fnFormatDatetime(this.adjform.get('adjdate').value),
          'grandtotal': this.adjform.get('grandtotal').value,
          'descr': this.adjform.get('descr').value,
          'adjtypeid': this.adjform.get('adjtypeid').value,
          'refno': this.adjform.get('refno').value,
          'inactive': this.adjform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
          'adjdetailscoll': this.adjdetailscoll,
        }

        if (this.adjform.get('adjid').value > 0) {

          this.fnSetAdj(data);
        }
        else {

          this.fnInsertAdj(data);
        }

      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }

  }

  //Insert
  fnInsertAdj(data) {

    this.appService.fnInsertAdj(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status == 200) {
          this.toastr.success('', "The new Adjustment has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.adjno);

          var _result = res.json().result;
          if (_result.length > 0) {
            this.fnEditFormEdit(_result[0].adjid);
          }

        } else {
          this.toastr.error('Error', res.json().err_message);
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetAdj(data) {

    this.appService.fnSetAdj(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status == 200) {
          this.toastr.success('', "The Adjustment has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.adjid, data.adjno);

          this.fnEditFormEdit(this.adjid);
        } else {
          this.toastr.error('Error', res.json().err_message);
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }


  private fnEditMode(deptBO) {

    deptBO.adjdate = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.adjdate));


    this.adjform.setValue({

      adjid: deptBO.adjid,
      adjno: deptBO.adjno,
      adjdate: deptBO.adjdate,
      grandtotal: deptBO.grandtotal,
      descr: deptBO.descr,
      adjtypeid: deptBO.adjtypeid,
      refno: deptBO.refno,
      inactive: deptBO.inactive,

    });




    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = false;

    if (this.formmode === 'EDIT') {
      this.iseditmode = true;
    }
    else {
      this.isviewmode = true;
    }
  }


  fnEditBtnClick() {
    this.iseditmode = true;

    this.isviewmode = false;
  }




  fnEditFormEdit(id) {

    this.adjid = id;
    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;


    //this.ngOnInit();

    this.ismanualclose = true;
    this.fnCloseForm();

  }

  //Close
  async fnCloseForm() {

    try {

      if ((this.isaddmode || this.iseditmode) && !this.ismanualclose) {
        var a = await this.loginService.fnConfirmFormLeave();
        if (a === false) {
          return false;
        }
      }

      this.ismanualclose = true;


      this.emitData.emit("");
      this.activeModal.close(true);

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  @HostListener('window:beforeunload')
  canDeactivate(): any {

    if (this.ismanualclose || this.isviewmode) {
      return true;
    }
    else {
      return false;
    }
  }

  //Details

  fnGetRawmaterial() {
    this.isLoadingResult = true;

    var data = {
      'rawmaterialid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getRawmaterial(data)
      .subscribe(
        (res) => {
          this.rawmaterialColl = res.json().result;

          this.isLoadingResult = false;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fnReLoadRawmaterial(index) {


    var data = {
      'rawmaterialid': 0,
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getRawmaterial(data)
      .subscribe(
        (res) => {
          this.fnChangeRawmaterial(index)
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fnCalcDetails() {

    for (let row of this.adjdetailscoll) {
      row.subtotal = row.qty * row.unitprice;
      this.subtotal = this.subtotal + Number(row.subtotal)



    }
    this.fnCalcsSummaryTotal()
  }




  fnCalcsSummaryTotal() {
    this.qtytotal = 0;
    this.unitpricetotal = 0;
    this.subtotal = 0;


    for (let row of this.adjdetailscoll) {
      this.qtytotal = Number(this.fnConvertDecimal(this.qtytotal)) + Number(this.fnConvertDecimal(row.qty))
      this.unitpricetotal = Number(this.fnConvertDecimal(this.unitpricetotal)) + row.unitprice
      this.subtotal = Number(this.fnConvertDecimal(this.subtotal)) + row.subtotal

    }
    this.adjform.patchValue({ grandtotal: this.subtotal })
  }




  fnDeleteadjConfirm(index) {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete details?')
        .then((confirmed) => {
          if (confirmed) {
            this.adjdetailscoll.splice(index, 1)
            if (this.adjdetailscoll.length === 0) {
              this.fnSetFirstRowItem()
            }
            this.fnCalcDetails()
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  fnChangeRawmaterial(index) {

    var _prodname = "", _unitprice = 0,_uomid=0;

    for (let abo of this.rawmaterialColl) {
      if (this.adjdetailscoll[index].rawmaterialid === abo.rawmaterialid) {
        _prodname = abo.rawmaterialname;
        _unitprice = abo.purchaseprice;
        _uomid=abo.purchaseuomid

      }
    }
    this.adjdetailscoll[index].rawmaterialname = _prodname;
    this.adjdetailscoll[index].unitprice = _unitprice;
    this.adjdetailscoll[index].uomid=_uomid
    this.fnChangeUom(index)

  }


  fnSetFirstRowItem() {
    if (this.adjdetailscoll.length > 0) {
      if (!this.adjdetailscoll[this.adjdetailscoll.length - 1].rawmaterialid) {
        return
      }
    }

    var data = {
      adjdetailsid: 0,
      adjid: 0,
      rawmaterialid: null,
      rawmaterialname: '',
      qty: 0,
      unitprice: 0,
      subtotal: 0,

    }

    this.adjdetailscoll.push(data)

  }
  fnGetFirstRowItem() {

    var data = {
      adjdetailsid:null,
      adjid: null,
      rawmaterialid: null,
      rawmaterialname: '',
      uomid: null,
      uomidname: '',
      qty: null,
      unitprice:null,
      subtotal:null,     
      taxid: null,
      taxname: '',
      taxrate: null,
      taxamt: null,
      cgsttaxrate: 0,
      cgsttaxamt: 0,
      sgsttaxrate: 0,
      sgsttaxamt: 0,
      igsttaxrate: 0,
      igsttaxamt: 0,
      taxable: 0,
      nettotal:null
    }

    return data;

  }

  
  fnChangeUom(index) {

    var  _uomid = null, _uomname = null;

    for (let abo of this.uomColl) {
      if (this.adjdetailscoll[index].uomid === abo.uomid) {
        _uomname = abo.uomname;
        _uomid = abo.uomid;
       
      }
    }
    this.adjdetailscoll[index].uomname = _uomname;
    this.adjdetailscoll[index].uomid = _uomid;

  }



  //Focus
  fnFocusChangeGridRow(index) {
    this.gridfocusrow = index

  }

  fnSetNextFocus(index) {

    if (this.adjdetailscoll.length > 0) {

      if (this.adjdetailscoll.length > index + 1) {
        this.gridfocusrow = index + 1
      }
    }


  }


  //Addadjtype
  private fnAddAdjType() {

    const modalRef = this.productFindService.open(AddadjtypeComponent, { size: <any>'m' });


    modalRef.componentInstance.ngOnInit();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetAdjtype();

      if (receivedEntry > 0) {
        this.adjform.patchValue({ adjtypeid: receivedEntry })
      }
    });

  }
  //AddProduct
  private fnAddRawmaterial(index) {

    const modalRef = this.productFindService.open(AddrawmaterialComponent, { size: <any>'xxl' });
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fnGetRawmaterial();

      if (receivedEntry > 0) {
        this.adjdetailscoll[index].rawmaterialid = receivedEntry
      }
      this.fnReLoadRawmaterial(index);

    });
  }
  //Print
  // private fnPrintadj() {

  //   const modalRef = this.productFindService.open(PrintComponent, { size: <any>'l', backdrop: 'static' });
  //   modalRef.componentInstance.trxid = this.adjid;
  //   modalRef.componentInstance.doctype = this.formname;

  //   modalRef.componentInstance.emitData.subscribe((receivedEntry) => {



  //   });

  // }
  //Print
  // private fnGldetails() {

  //   const modalRef = this.productFindService.open(GldetailscommonComponent, { size: <any>'l', backdrop: 'static' });
  //   modalRef.componentInstance.trxid = this.adjid;
  //   modalRef.componentInstance.doctype = this.formname;

  //   modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

  //   });

  // }


  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId()

      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }

  fnConvertDecimal(value) {
    if (!value) {
      return 0
    }
    else {
      return value
    }

  }


  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }

  fnAddadjdetails() {

    const modalRef = this.productFindService.open(AddadjdetailComponent, { size: <any>'l' });
    modalRef.componentInstance.adjdetailsBO=this.fnGetFirstRowItem()
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      if (receivedEntry.checkstatus === "DONE") {
        this.fnSetFirstRowItem()
        this.adjdetailscoll[this.adjdetailscoll.length - 1] = receivedEntry.data;
        this.fnCalcDetails()
      }
    });
  }

  
  fnPostingConfirm(type) {
    this.confirmationDialogService.confirm('Confirm..', 'Do you  want to ' + type + ' Adjustment?')
      .then((confirmed) => {
        if (confirmed) {
          if (type === 'Post') {
            this.fnPosting()
          }
          else if (type === 'UnPost') {
            this.fnUnPosting()
          }

        }
      }
      );
  }


  fnPosting() {
    var data = {
      trxid: this.adjid,
      doctype: 'ADJUSTMENT',
      postingtype: 'MANUAL',
      modifiedby: this.loginService.fnGetModUserId()

    }
    this.appService.fnInsertPostings(data)
      .subscribe(
        (res) => {
         
          if (res.json().status === 200) {
        
            this.fnEditFormEdit(this.adjid);
          }
          else {
            this.toastr.error('Error', res.json().err_message);
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fnUnPosting() {
    var data = {
      trxid: this.adjid,
      doctype: 'ADJUSTMENT',
      postingtype: 'MANUAL',
      modifiedby: this.loginService.fnGetModUserId()

    }
    this.appService.fnInsertUnPostings(data)
      .subscribe(
        (res) => {
          
          if (res.json().status === 200) {
          
            var result=res.json().result;
           
            if(result.length>0){
         
              if(result[0].checkresult==='DONE'){
                this.fnEditFormEdit(this.adjid);
              }
              else{
                this.toastr.error('Error', result[0].checkresultmsg);
              }
            }
           
          }
          else {
            this.toastr.error('Error', res.json().err_message);
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  
  fnEnableEditBtn() {
    if(this.adjBO.iscancelled===1){
      return false;
    }
    else if (this.adjBO.isposted === 1) {
      return false;
    }
    else {
      return true;
    }
  }

  fnEnablePostBtn() {
    if(this.adjBO.iscancelled===1){
      return false;
    }
    else  if (this.adjBO.isposted === 1) {
      return false;
    }
    else {
      return true;
    }
  }


  
  fnEnableUnPostBtn() {
    if (this.adjBO.isposted === 1) {
      return true;
    }
    else {
      return false;
    }
    
  }
  aaNumber(total) {

    if (isNaN(total) || total === undefined || total === null) {
      return Number(0)
    }
    else {
      return Number.parseFloat(Number(total).toFixed(2))
    }
  }

  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }






}
